import React from 'react';

import { InfoBox } from '@infoods/lifebase-ui';

import classes from './InbodyIndicatorsChartView.module.scss';
import { InbodyIndicatorInfo } from '../../../../../../interfaces/inbodyIndicator';
import { MealPlanOnScanDayInfo } from '../../../../../../interfaces/mealPlanOnScanDayInfo';
import { InbodyType } from '../../../../../../../shared/constants/inbody-info/InbodyType';
import { Flags } from '../../../../../../../utils-types';
import { IndicatorChart } from '../IndicatorChart/IndicatorChart';
import { getChartTitle } from '../../utils/getChartTitle';

type InbodyIndicatorsChartViewProps = {
  customerInbodyIndicators: InbodyIndicatorInfo[];
  mealPlansOnScanDay: MealPlanOnScanDayInfo[];
  customerInbodyTypeFlags: Flags<InbodyType>;
};

const InbodyIndicatorsChartView = ({
  customerInbodyIndicators,
  mealPlansOnScanDay,
  customerInbodyTypeFlags,
}: InbodyIndicatorsChartViewProps) => {
  return customerInbodyIndicators.map((indicator) => {
    const { label, measurement, key } = indicator;

    const chartTitle = getChartTitle(label, measurement);

    return (
      <InfoBox
        title={chartTitle}
        key={key}
        customContentPadding
        className={classes.chartContainer}
      >
        <IndicatorChart
          indicator={indicator}
          mealPlansOnScanDay={mealPlansOnScanDay}
          customerInbodyTypeFlags={customerInbodyTypeFlags}
          shortListLimit={16}
        />
      </InfoBox>
    );
  });
};

export { InbodyIndicatorsChartView };
